import { Button } from "@eventbrite/valkyrie-eds-button";
import { Icon } from "@eventbrite/valkyrie-eds-icon";
import { ChevronDownChunky } from "@eventbrite/valkyrie-eds-iconography";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useScrollWatcher } from "./hooks";

import styles from "./Modal.module.scss";

export interface BarButtonProps {
  onClick(): void;
  title?: string;
}

export const BarButton: React.FunctionComponent<BarButtonProps> = (props) => {
  const { onClick, title } = props;
  const [isSticky, setIsSticky] = useState(false);
  const [height, setHeight] = useState(36);
  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (buttonRef && buttonRef.current)
      setHeight(buttonRef.current.offsetHeight);
  }, [buttonRef]);

  useScrollWatcher(
    (pos) => {
      const shouldStick = pos > height;
      if (isSticky !== shouldStick) {
        setIsSticky(shouldStick);
      }
    },
    {
      deps: [isSticky, height],
      interval: 10,
      selector: "#edsModalContentChildren",
    },
  );

  return (
    <Button
      data-testid="modal-close-bar-button"
      style="none"
      title={title}
      onClick={onClick}
    >
      <div
        ref={buttonRef}
        className={classNames(styles.barButton, {
          [styles.barButtonSticky as string]: isSticky,
        })}
      >
        <Icon size="medium" type={<ChevronDownChunky />} />
      </div>
    </Button>
  );
};
